import React from 'react';
import {Box, Typography} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import WarningIcon from '@mui/icons-material/Warning';
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import {PlanRow} from '../CreateBuilder/BuilderSourceDestination/PlanRow';
import {PlanAccordionShell} from '../CreateBuilder/BuilderSourceDestination/PlanAccordionShell';
import {PlanValidationIcon} from '../CreateBuilder/BuilderSourceDestination/PlanValidationIcon';
import {usePlanValidationLevel} from '../CreateBuilder/BuilderSourceDestination/usePlanValidationLevel';
import {
  ValidationObjectType,
  getValidationLevel,
} from '../CreateBuilder/BuilderSourceDestination/builderValidators';
import {planFormClasses} from '../CreateBuilder/BuilderSourceDestination/planFormClasses';
import {VALIDATION} from '../CreateBuilder/BuilderSourceDestination/BUILDER_VALIDATION';
import AutoField from '../../../components/AutoForm/AutoFieldNew';
import {
  annuityGuaranteePeriodField,
  annuityIncomeFrequencyField,
  annuityIndexLinkedField,
  annuityLongTermCareField,
  annuityLtcProtectedPercentField,
  annuityNotesField,
  annuityPaymentTypeField,
  annuityRateTypeField,
  annuitySpousePercentField,
  annuityTypeField,
} from './builderAnnuityFields';
import {useAutoField} from '../../../components/AutoForm/useAutoForm';

interface AnnuityDestinationRowProps {
  validation: ValidationObjectType;
}

export const AnnuityDestinationRow: React.FC<AnnuityDestinationRowProps> = ({
  validation,
}) => {
  const [longTermCareField] = useAutoField<boolean>(
    'annuity.longTermCareCapitalProtected'
  );

  const level = getValidationLevel(validation);
  const bgClass =
    level === VALIDATION.VALID
      ? 'valid'
      : level === VALIDATION.INVALID
      ? 'invalid'
      : level === VALIDATION.PARTIALLY_VALID
      ? 'partial'
      : 'nothing';

  return (
    <PlanRow id="annuity" reccId="" isSelected isSubplan={false}>
      <PlanAccordionShell
        expanded
        isSelected
        isSoleParent
        validationLevel={bgClass}
        summaryChildren={
          <Typography variant="subtitle1" gutterBottom>
            Annuity Details
          </Typography>
        }
        summaryTrailing={
          validation ? (
            <Box sx={planFormClasses.validationIcon}>
              {level === VALIDATION.VALID && <CheckIcon />}
              {level === VALIDATION.PARTIALLY_VALID && <WarningIcon />}
              {level === VALIDATION.INVALID && <NotInterestedIcon />}
            </Box>
          ) : undefined
        }
      >
        <Box sx={{'& > *': {mb: '1rem !important'}}}>
          <AutoField field={annuityTypeField} />
          <AutoField field={annuityPaymentTypeField} />
          <AutoField field={annuityIncomeFrequencyField} />
          <AutoField field={annuityGuaranteePeriodField} />
          <AutoField field={annuitySpousePercentField} />
          <AutoField field={annuityRateTypeField} />
          <AutoField field={annuityIndexLinkedField} />
          <AutoField field={annuityLongTermCareField} />
          {longTermCareField.value && (
            <AutoField field={annuityLtcProtectedPercentField} />
          )}
          <AutoField field={annuityNotesField} />
        </Box>
      </PlanAccordionShell>
    </PlanRow>
  );
};
